import { format } from 'date-fns';
import { formatInTimeZone as formatTz } from 'date-fns-tz';

const isValidDate = (date?: string | Date) => {
  if (!date) {
    return false;
  }

  return typeof date === 'string' || (date instanceof Date && !!date.getDate());
};

export const formatInTimezone = (date: Date | string = '', timeZoneName: string, dateFormat?: string): string => {
  if (!isValidDate(date) || !dateFormat) {
    return '';
  }

  return formatTz(date, timeZoneName, dateFormat);
};

export const formatDate = (date: Date | string, dateFormat: string): string => {
  if (!date || !dateFormat) {
    return '';
  }

  return format(new Date(date), dateFormat);
};
